export const SalesAreaModuleTranslations: Array<string> = [
    'xmlSalesArea',
    'xmlSalesAreaAssignments',
    'xmlSalesOrganizations',
    'xmlDistributionChannels',
    'xmlDivisions',
    'xmlTermsOfPayment',
    'xmlShippingConditions',
    'xmlIncoterms',
    'xmlSalesOrganizationVisibility',
    'xmlBusinessPartnersFunctions',
    'Admin.Msg.EditTitle',
    'xmlSalesAreaMigration',
    'Admin.SelectLanguage',

    //Sales Organizations
    'SalesArea.Assigments.SalesOrganization',
    'SalesArea.SalesOrganization.DefaultCurrency',
    'SalesArea.SalesOrganization.Code',

    //Assigments
    'SalesArea.Assigments.QuickSearch',
    'SalesArea.Assigments.DistributionChannel',
    'SalesArea.Assigments.Division',

    //Parameters
    'SalesArea.Parameters',
    'SalesArea.Parameters.Events',
    'SalesArea.Parameters.EventsHintMessage',
    'SalesArea.Parameters.PartnerFunctions',
    'SalesArea.Parameters.PaymentTerms',
    'SalesArea.Parameters.ShippingConditions',
    'SalesArea.Parameters.Incoterms',
    'SalesArea.Parameters.IncotermsLocation',
    'SalesArea.Parameters.SalesOffice',
    'SalesArea.Parameters.SalesGroup',
    'SalesArea.Parameters.VCPIntegration',
    'SalesArea.Parameters.VCPIntegrationHintMessage',
    'SalesArea.Parameters.CustomerPricingProcedure',
    'SalesArea.Parameters.ExchangeRateType',

    //Sales Organization Visiblity
    'SalesArea.SalesOrganizationIsRequired',
    'SalesArea.InvalidSalesOrganizationVisibility',
    'SalesArea.SalesOrganizationVisibility.QuickSearch',
    'SalesArea.SalesOrganizationVisibility.AvailableSalesOrganizations',
    'SalesArea.SalesOrganizationVisibility.SelectedSalesOrganizations',
    'SalesArea.SalesOrganizationVisibility.NameIsRequired',
    'SalesArea.SalesOrganizationVisibility.PermissionIsRequired',
    'SalesArea.SalesOrganizationVisibility.DuplicateSalesOrganizations',
    'SalesArea.SalesOrganizationVisibility.DuplicatePermissions',
    'SalesArea.SalesOrganizationVisibility.PermissionDoesNotExists',
    'SalesArea.SalesOrganizationVisibility.InvalidId',
    'SalesArea.SalesOrganizationVisibility.ProvidedIdsDontExist',
    'Admin.deflusersetup.PlaceholderForSelectUser',

    //Payment Terms
    'PaymentTerms.Translate',
    'Paymentterms.Information',
     //Division
    'Division.Translate',
    'Division.Information',
    //DistributionChannels
    'DistributionChannels.Translate',
    'DistributionChannels.Information',
    //IncoTerm
    'IncoTerm.Translate',
    'IncoTerm.Information',
    //SalesOrganization
    'SalesOrganization.Translate',
    'SalesOrganization.Information',
    //Shipping
    'ShippingCondition.Translate',
    'ShippingCondition.Information',

    //Common Division
    'xmlCommonDivision',
    'CommonDivision.SalesOrganization',
    'CommonDivision.Division',
    'CommonDivision.DivisionCustomers',
];
